import React from 'react'

export const DownloadIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="428"
    height="512"
    viewBox="0 0 428 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M278 149.333V0H64.667C29.3177 0 0.666992 28.6507 0.666992 64V512H427.334V149.333H278ZM243.995 414.229C235.718 422.507 224.859 426.624 214 426.624C203.142 426.624 192.262 422.507 184.006 414.229L113.627 343.851L143.792 313.685L192.667 362.56V234.624H235.334V362.795L284.208 313.685L314.374 343.851L243.995 414.229ZM414.832 106.667H320.667V12.5013L414.832 106.667Z"
      fill="#020122"
    />
  </svg>
)
